// One key per cached server list, so every screen that reads a list shares
// one cache entry (and one request).
export const queryKeys = {
  zones: (system) => ['zones', system],
};
